import { LoadableAfterPaint } from '@confluence/loadable';

export const PageSizeSplitterLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageSizeSplitter" */ '../src/components/PageSizeSplitter.tsx'
			)
		).PageSizeSplitter,
});
